export const invalidHosts = [
  "google.com",
  "wikipedia.com",
  "facebook.com",
  "mail.google.com",
];

export const linkedinProfileLink = "https://www.linkedin.com/in/";
